import { createFileRoute, redirect } from "@tanstack/react-router";

// Old section slugs match the new FAQ category slugs, so deep links survive.
export const Route = createFileRoute("/help/$section/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/faq/$category", params: { category: params.section } });
  },
});
